import { render, staticRenderFns } from "./personalDataAgreementModal.vue?vue&type=template&id=20093e74"
import script from "./personalDataAgreementModal.vue?vue&type=script&lang=js"
export * from "./personalDataAgreementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports